var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85716 6.80769C4.85716 4.70476 6.61606 3 8.78576 3C10.9555 3 12.7144 4.70476 12.7144 6.80769C12.7144 8.91062 10.9555 10.6154 8.78576 10.6154C6.61606 10.6154 4.85716 8.91062 4.85716 6.80769Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 8.88462C14.1429 7.16404 15.582 5.76923 17.3573 5.76923C19.1325 5.76923 20.5716 7.16404 20.5716 8.88462C20.5716 10.6052 19.1325 12 17.3573 12C15.582 12 14.1429 10.6052 14.1429 8.88462Z",
    fill: "#D5DAE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5769C2 14.9446 5.03809 12 8.78576 12C12.5334 12 15.5715 14.9446 15.5715 18.5769V18.5793C15.5715 18.616 15.5712 18.6529 15.5706 18.6895C15.5664 18.9281 15.4358 19.1478 15.2248 19.2709C13.3436 20.3687 11.1397 21 8.78576 21C6.43187 21 4.22792 20.3687 2.34673 19.2709C2.13578 19.1478 2.00512 18.9281 2.00098 18.6895C2.00033 18.6521 2 18.6145 2 18.5769Z",
    fill: "#D5DAE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5798C16.9999 18.6242 16.9995 18.6687 16.9988 18.7128C16.9934 19.0254 16.9156 19.3272 16.7769 19.5987C16.9689 19.6098 17.1623 19.6154 17.3571 19.6154C18.8768 19.6154 20.3164 19.2741 21.5967 18.6658C21.832 18.554 21.9852 18.3264 21.996 18.0726C21.9987 18.0103 22 17.9476 22 17.8846C22 15.3993 19.9213 13.3846 17.3571 13.3846C16.6462 13.3846 15.9726 13.5395 15.3703 13.8163C16.3939 15.1441 17 16.7919 17 18.5769V18.5798Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.4ebac9ef80d3bf01f6c0181af0c3119c.svg";
export { ForwardRef as ReactComponent };